import { useUnit } from 'effector-react';
import { CircleSlash2 } from 'lucide-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { WalletWithAccountId } from 'shared/api';
import { ConfirmModalProps, createConfirmModal, ModalFormActionIconProps } from 'shared/ui';
import { UnblockWalletModel } from '../../model';

export const createUnblockWalletModal = (model: UnblockWalletModel) => {
	const ConfirmModal = createConfirmModal(model);

	const UnblockWalletModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		const [wallet] = useUnit([model.$modalData]);

		return (
			<ConfirmModal
				ref={ref}
				title={t('unblock-wallet.title')}
				cancelButtonProps={{
					children: t('unblock-wallet.cancel'),
				}}
				submitButtonProps={{
					variant: 'outline',
					children: t('unblock-wallet.unblock'),
				}}
				{...props}
			>
				{t('unblock-wallet.description', { name: wallet?.currency })}
			</ConfirmModal>
		);
	});

	const UnblockWalletModalActionIcon = forwardRef<
		HTMLButtonElement,
		ModalFormActionIconProps<WalletWithAccountId>
	>(({ modalData, ...props }, ref) => {
		const viewerAccountId = useUnit(viewerModel.$accountId);

		return (
			<ConfirmModal.ActionIcon
				ref={ref}
				data-test-id='unblock-wallet-button'
				variant='ghost-destructive'
				disabled={viewerAccountId === modalData.accountId}
				modalData={modalData}
				{...props}
			>
				<CircleSlash2 />
			</ConfirmModal.ActionIcon>
		);
	});

	return Object.assign(UnblockWalletModal, {
		ActionIcon: UnblockWalletModalActionIcon,
	});
};
